module.exports = __webpack_public_path__ + "static/media/ana-20-anos-new.422e9b24.png";